import { store } from '../../../redux/store';

export const getSSOLoginFlag = (): boolean => {
  return store.getState().App?.systemFlags?.P40_52117_login_with_SSO;
};
